export default {
  common: {
    language: "Язык",
    logout: "Выход",
    yes: "Да",
    no: "Нет"
  },
  languages: {
    uk: "Українська",
    ru: "Русский",
    en: "English"
  },
  notifications: {
    error: "Ошибка",
    loginError: "Ошибка входа",
    restoreError: "Ошибка восстановления",
    changePasswordError: "Ошибка изменения пароля"
  },
  auth: {
    login: {
      title: "Вход в систему",
      subtitle: "Войдите, чтобы получить доступ",
      passwordPlaceholder: "Пароль",
      submit: "Войти",
      forgotPassword: "Забыли пароль?",
      noAccountTitle: "Нет аккаунта?",
      noAccountDesc:
        "Зарегистрируйтесь сейчас, чтобы иметь доступ к функциям системы",
      register: "Зарегистрироваться"
    },
    restore: {
      title: "Восстановление пароля",
      subtitle: "Введите почту, на которую зарегистрирован аккаунт",
      emailNotFound: "Этот email не существует в системе.",
      submit: "Восстановить",
      sentMessagePrefix: "На указанный адрес",
      sentMessageSuffix:
        "было отправлено письмо с дальнейшими инструкциями по восстановлению пароля"
    },
    changePassword: {
      title: "Изменение пароля",
      oldPasswordPlaceholder: "Введите старый пароль",
      newPasswordPlaceholder: "Придумайте новый пароль",
      confirmPasswordPlaceholder: "Подтвердите новый пароль",
      weakPassword:
        "Пароль слишком слабый. Он должен содержать как минимум одну заглавную латинскую букву, одну цифру и иметь длину от 6 символов.",
      passwordsMismatch: "Пароли не совпадают.",
      submit: "Изменить"
    }
  },
  register: {
    title: "Регистрация на игру",
    subtitle: "Внимательно заполните все поля",
    callsignLabel: "Игровое имя*",
    callsignPlaceholder: "Позывной",
    cyrillicHint: "Только русские буквы!",
    requiredField: "Это обязательное поле.",
    callsignMinLength: "Позывной должен состоять минимум из {min} букв.",
    callsignNotUnique: "Такой позывной уже занят.",
    passportPhotoLabel: "Фото на паспорт*",
    uploadButton: "Загрузить",
    passportPhotoHint:
      "Необходимо выбрать и аккуратно обрезать фото, так как оно будет размещено на вашем игровом паспорте.",
    legendLabel: "Квента персонажа*",
    legendPlaceholder: "Опишите историю вашего персонажа",
    legendHint:
      "Без квенты заявки не принимаются. Максимальная длина - 1800 символов.",
    legendMinLength: "Квента должна состоять минимум из {min} символов.",
    legendMaxLength:
      "Квента должна состоять максимум из {max} символов. Пожалуйста, уменьшите размер текста.",
    contraindicationsLabel: "Противопоказания",
    contraindicationsPlaceholder:
      "Укажите ваши медицинские или др. противопоказания (если есть)",
    photosLabel: "Несколько фото в экипировке*",
    photosDragText: "Перетащите фото",
    photosBrowseText: "или нажмите сюда",
    photosPopupText: "загрузите изображение",
    photosDropText: "Отпустите здесь",
    photosHint:
      "Прикрепляйте СВОИ фото для прохождения дресс-кода. Каждое фото должно быть размером до 1МБ.",
    agreementTitle: "Соглашение",
    agreementRulesPrefix: "Я даю согласие и обязуюсь выполнять",
    agreementRulesLink: "правила",
    agreementRulesSuffix: "проведения мероприятия",
    agreementData:
      "Я даю согласие по своей воле и в своем интересе на хранение, обработку и использование предоставленных мною персональных данных",
    submit: "Зарегистрироваться",
    imageTooBig: "Изображение превышает допустимый размер 1МБ",
    errorTitle: "Ошибка регистрации",
    email: {
      label: "E-mail*",
      placeholder: "Email",
      hint: "напр. w.degtyarev@gmail.com",
      invalid: "Введенное значение некорректно.",
      invalidFormat: "Неверный формат адреса электронной почты.",
      notUnique: "Этот email уже занят.",
      tryLoginPrefix: "Попробуйте",
      tryLoginAction: "войти",
      tryLoginSuffix: "в систему."
    },
    fullName: {
      label: "Фамилия*, Имя*, Отчество",
      lastNamePlaceholder: "Фамилия",
      firstNamePlaceholder: "Имя",
      fatherNamePlaceholder: "Отчество",
      firstNameRequired: "Имя обязательное для заполнения поле.",
      firstNameMin: "Имя должно состоять минимум из {min} букв.",
      lastNameRequired: "Фамилия обязательное для заполнения поле.",
      lastNameMin: "Фамилия должна состоять минимум из {min} букв."
    },
    password: {
      label: "Пароль*",
      placeholder: "Придумайте пароль",
      confirmPlaceholder: "Подтвердите пароль",
      weak:
        "Пароль слишком слабый. Он должен иметь (как минимум) одну заглавную латинскую букву, одну цифру и состоять из 6 символов.",
      mismatch: "Пароли не соответствуют друг другу."
    },
    phone: {
      label: "Контактный телефон*",
      placeholder: "+38 (999) 999-9999",
      hint: "напр. +38 (999) 999-9999"
    },
    birthday: {
      label: "Дата рождения*",
      hint: "напр. 26.04.1986"
    },
    city: {
      label: "Город*",
      noOptions: "Давайте начнем искать...",
      noResult: "Пока не найдено :( Давай продолжим",
      hint: "Город, из которого будете добираться"
    },
    team: {
      label: "Команда*",
      placeholder: "Введите название своей команды, если не нашли в списке",
      hint:
        "Укажите свою страйкбольную команду или Внеком. Вы можете выбрать из существующих или ввести новую."
    },
    fractions: {
      label: "Группировка*",
      placesLeft: "мест"
    },
    suit: {
      label: "Костюм*",
      placeholder: "Выберите костюм"
    },
    forbidden: {
      title: "Регистрация на игру закрыта",
      subtitle: "Всем спасибо, мест больше нет"
    },
    success: {
      title: "Спасибо за заявку!",
      textPrefix: "После того, как она будет рассмотрена, на почту",
      textSuffix: "придет письмо с дальнейшими инструкциями",
      loginPrefix: "Вы можете",
      loginLink: "Войти в Систему",
      loginSuffix: "по указанным вами данным (email и пароль)"
    }
  },
  scan: {
    scanAnother: "Сканировать другого",
    errorTitle: "Ошибка сканирования"
  },
  components: {
    common: {
      none: "Нет",
      nothing: "Ничего",
      rub: "куп."
    },
    grid: {
      actions: "Действия",
      action: "Действие",
      total: "Всего записей"
    },
    memberData: {
      code: "Код",
      callsign: "Позывной",
      fraction: "Группировка",
      suit: "Костюм",
      legend: "Легенда",
      rank: "Ранг",
      experience: "Опыт",
      money: "Деньги",
      createdAt: "Создан",
      passportPhoto: "Фото на паспорт",
      lookPhoto: "Фото на допуск",
      profilePhotos: "Фото профиля",
      passport: "Паспорт",
      passportFront: "лицевая сторона",
      passportBack: "тыльная сторона",
      passportQr: "QR-код",
      generatePassport: "Сгенерировать паспорт",
      regeneratePassport: "Перегенерировать паспорт",
      legendTitle: "Легенда сталкера {callsign}",
      fractionTitle: "Описание группировки {title}",
      suitTitle: "Описание костюма {title}"
    },
    memberRequest: {
      closed: "Регистрация на {title} закрыта",
      hasPassport: "Наличие игрового паспорта",
      passportYes: "В наличии",
      passportLost: "Утерян"
    },
    regPending: {
      pending: "Что выдать"
    },
    userData: {
      fullName: "ФИО",
      phone: "Телефон",
      bornAt: "Дата рождения",
      city: "Город",
      team: "Команда",
      contraindications: "Противопоказания"
    },
    notifications: {
      whatChanged: "Что поменялось",
      legendDiffTitle: "Подробности изменений в легенде",
      before: "До",
      after: "После"
    },
    gpsAdd: {
      hint:
        "Здесь можно установить вашу текущую GPS-позицию как координаты объекта",
      unavailable: "Геолокация недоступна",
      addMark: "Добавить метку"
    }
  },
  member: {
    character: {
      back: "Назад",
      createLimitNote:
        "Обратите внимание: максимальное количество ваших персонажей - 3.",
      createActiveNote:
        "Новый персонаж станет активным для подачи на игру. Выбирайте мудро.",
      passportPhotoLabelEdit: "Фото на паспорт",
      uploadNew: "Загрузить новое",
      passportLocked:
        "Редактирование фото на паспорт невозможно, т.к. у вас уже есть паспорт.",
      suitLabelEdit: "Костюм",
      suitLocked:
        "Изменение костюма недоступно, т.к. у вас уже есть подтвержденная заявка на ближайшее мероприятие.",
      legendLabelEdit: "Квента персонажа",
      legendLocked:
        "Изменение квенты недоступно, т.к. у вас уже есть подтвержденная заявка на ближайшее мероприятие.",
      photosLabelEdit: "Несколько фото в экипировке",
      photosLocked:
        "Изменение фотографий на допуск недоступно, т.к. у вас уже есть подтвержденная заявка на ближайшее мероприятие.",
      saveChanges: "Сохранить изменения",
      saved: "Данные сохранены"
    },
    profile: {
      addCharacter: "Добавить персонажа",
      createBlocked:
        "Создание нового персонажа недоступно, так как у вас уже есть подтвержденная заявка на ближайшее мероприятие"
    },
    members: {
      callsign: "Позывной:",
      suit: "Костюм:",
      rank: "Ранг:"
    },
    events: {
      noActive: "Пока нет доступных мероприятий",
      dates: "Даты проведения",
      feeBefore: "Взнос до {date}",
      yourFeeBefore: "Ваш взнос до {date}",
      feeAfter: "Взнос после {date}",
      yourFeeAfter: "Ваш взнос после {date}",
      feeAfterReg: "Взнос после {date}",
      yourFeeAfterReg: "Ваш взнос после {date}",
      regClosing: "закрытие регистрации",
      history: "История",
      participants: "Участники",
      showParticipants: "Показать {count} участников",
      requests: "Заявки",
      requestStatus: "Статус заявки:",
      organizerComment: "Комментарий организатора",
      submitRequest: "Подать заявку",
      fractionFull: "К сожалению, ваша группировка уже заполнена",
      historyTitle: "История мероприятия: {title}",
      requestTitle: "Заявка на мероприятие: {title}"
    }
  },
  admin: {
    edit: {
      back: "Назад",
      save: "Сохранить"
    },
    common: {
      refresh: "Обновить",
      userDataTitle: "Данные о пользователе",
      memberDataTitle: "Данные об игроке"
    },
    members: {
      income: "Доход",
      cols: {
        city: "Город",
        callsign: "Позывной",
        lastName: "Фамилия",
        firstName: "Имя",
        fraction: "Группировка",
        paid: "Заплатил",
        paymentType: "Тип оплаты",
        requestDate: "Дата заявки"
      }
    },
    registration: {
      pendingDataTitle: "Данные о выдаче",
      cols: {
        suit: "Костюм",
        rank: "Ранг",
        experience: "Опыт",
        money: "Деньги",
        pending: "До выдачи"
      },
      moneyValue: "{value} куп.",
      pendingCount: "{count} предмет(ов)",
      pendingEmpty: "Ничего"
    },
    notifications: {
      newCount: "Новых уведомлений: {count}",
      view: "Просмотреть",
      changeTitle: "Просмотр изменения",
      processSuccess: "Изменение помечено как прочитанное",
      cols: {
        type: "Тип изменения",
        readBy: "Кем прочитано",
        updatedAt: "Дата изменения"
      }
    },
    requests: {
      organizerCommentTitle: "Комментарий организатора",
      confirmModalTitle: "Подтверждение заявки от {who}",
      commentModalTitle: "Комментарий к заявке от {who}",
      rejectModalTitle: "Отклонение заявки от {who}",
      payModalTitle: "Оплата регистрации от {who}",
      feeDiscount: "Взнос со временной скидкой",
      feeNoDiscount: "Взнос без временной скидки",
      feeAfterClose: "Взнос после закрытия регистрации",
      addComment: "Добавить комментарий",
      comment: "Комментарий",
      confirmCommentPlaceholder:
        "Добавьте комментарий к письму с подтверждением заявки (необязательно)",
      commentPlaceholder: "Добавьте комментарий к письму",
      howMuchPaid: "Сколько оплатил?",
      paidDescription: "(суммарно, если была оплата частями)",
      notPaid: "не платил",
      paymentType: "Тип оплаты",
      forceFullDescription:
        "(включать в случае, если необходимо отметить полную оплату, когда не вся сумма была заплачена)",
      forceFullPayment: "Форсировать полный платеж",
      free: "бесплатно",
      currency: "грн",
      descToDate: "* сколько игрок должен заплатить до {date}",
      descAfterDate: "* сколько игрок должен заплатить после {date}",
      descAfterReg:
        "* сколько игрок должен заплатить после {date} (закрытия регистрации)",
      cols: {
        passport: "Паспорт?",
        fee: "Взнос",
        discountFee: "Со скидкой",
        updated: "Изменен",
        legendOk: "Квента ОК?",
        lookOk: '"Антураж" ОК?',
        status: "Статус"
      },
      actions: {
        lookApprove: 'Одобрить "антураж"',
        legendApprove: "Одобрить квенту",
        approve: "Подтвердить",
        comment: "Комментировать",
        reject: "Отклонить",
        payed: "Оплатил"
      }
    },
    firmwareAdd: {
      nameLabel: "Название прошивки",
      fileLabel: "Бинарный файл прошивки",
      typeLabel: "Тип прошивки",
      descLabel: "Описание",
      descPlaceholder: "Добавьте описание к прошивке (необязательно)",
      tagLabel: "Тег",
      currentLabel: "Текущая?",
      currentDesc: "Такая прошивка станет текущей",
      add: "Добавить",
      savedTitle: "Прошивка добавлена",
      savedBody: 'Версия прошивки "{title}" (ID = {id}):'
    },
    firmwaresList: {
      add: "Добавить",
      cols: {
        type: "Тип",
        tag: "Тег",
        version: "Версия",
        current: "Текущая?",
        file: "Файл",
        createdAt: "Дата создания"
      }
    },
    itemsList: {
      add: "Добавить",
      noCode: "нет",
      cols: {
        code: "Код",
        title: "Название",
        type: "Тип предмета",
        owner: "Чей предмет?",
        place: "Базовое расположение",
        createdAt: "Дата создания"
      },
      actions: {
        edit: "Редактировать"
      }
    },
    charactersList: {
      add: "Добавить",
      noCode: "нет",
      cols: {
        code: "Код",
        title: "Название",
        type: "Тип предмета",
        owner: "Чей предмет?",
        location: "Базовое расположение",
        createdAt: "Дата создания"
      },
      actions: {
        edit: "Редактировать"
      }
    },
    locationsList: {
      add: "Добавить",
      cols: {
        title: "Название",
        type: "Тип локации",
        createdAt: "Дата создания"
      },
      actions: {
        edit: "Редактировать"
      }
    },
    itemEdit: {
      nameLabel: "Название предмета",
      photoLabel: "Фото",
      descLabel: "Описание",
      descPlaceholder: "Добавьте описание к предмету (необязательно)",
      typeLabel: "Тип предмета",
      placeLabel: "Базовое расположение",
      locationBindLabel: "Привязка к локации",
      locationPlaceholder: "Введите локацию",
      locationNotFound: "Локация не найдена",
      ownerLabel: "Принадлежность",
      activeLabel: "Активный?",
      activeDesc: "Предмет можно деактивировать, чтобы он нигде не отображался",
      virtualLabel: "Виртуальный?",
      virtualDesc:
        '"Виртуальные" предметы нужны для составления списка цен, например аптечки',
      gpsLabel: "Расположение",
      addLocation: "Добавить расположение",
      addComment: "Добавить комментарий",
      commentLabel: "Комментарий",
      commentPlaceholder: "Добавьте комментарий к предмету (необязательно)",
      gpsModalTitle: "Добавление GPS-метки",
      savedTitle: "Предмет сохранен",
      savedCode: 'Код для предмета "{title}" (ID = {id}):'
    },
    locationEdit: {
      nameLabel: "Название локации",
      photoLabel: "Фото {index}",
      descLabel: "Описание",
      descPlaceholder: "Добавьте описание к локации (необязательно)",
      typeLabel: "Тип локации",
      zoneLabel: "Зона",
      gpsLabel: "Расположение",
      addLocation: "Добавить расположение",
      activeLabel: "Активная?",
      activeDesc:
        "Локацию можно деактивировать, чтобы она нигде не отображалась",
      gpsModalTitle: "Добавление GPS-метки",
      savedTitle: "Локация сохранена",
      savedBody: 'Локация "{title}" (ID = {id}) успешно сохранена'
    },
    characterEdit: {
      nameLabel: "Название персонажа",
      photoLabel: "Фото",
      descLabel: "Описание",
      descPlaceholder: "Добавьте описание к персонажу (необязательно)",
      addComment: "Добавить комментарий",
      commentLabel: "Комментарий",
      commentPlaceholder: "Добавьте комментарий к персонажу (необязательно)",
      savedTitle: "Персонаж сохранен",
      savedCode: 'Код для персонажа "{title}" (ID = {id}):'
    }
  },
  enums: {
    common: {
      noCommand: "Вне команд"
    },
    rank: {
      novice: "Новичок",
      experienced: "Опытный",
      veteran: "Ветеран",
      master: "Мастер",
      legend: "Легенда"
    },
    pda: {
      own: "Свой",
      rent: "Аренда",
      purchase: "Покупка",
      none: "Нет"
    },
    shotLight: {
      own: "Свой",
      purchase: "Покупка",
      none: "Нет"
    },
    request: {
      approved: "Подтверждена",
      commented: "Оставлен комментарий",
      declined: "Отклонена",
      partially_paid: "Частично оплачена",
      paid: "Оплачена",
      none: "На рассмотрении"
    },
    paymentType: {
      cashless: "Безнал",
      cash: "Наличка",
      combatant: "УБД",
      free: "Бесплатно",
      none: "Не платил"
    },
    itemType: {
      suit: "Костюм",
      artefact: "Артефакт",
      quest: "Квестовый",
      other: "Другое"
    },
    itemOwner: {
      own: "Клубный",
      personal: "Личный",
      other: "Чужой/Другое"
    },
    itemPlace: {
      storage: "Склад",
      garage: "Гараж",
      home: "Дом",
      other: "Другое"
    },
    firmwareType: {
      unknown: "Неизвестно",
      artefact: "Артефакт",
      soul: 'ПДА "Душа"',
      anomaly: "Аномалия",
      defence: "Незламність"
    },
    locationType: {
      main: "Основная",
      quest: "Квестовая",
      other: "Другая"
    },
    locationZone: {
      red: "Красная",
      yellow: "Желтая",
      green: "Зеленая",
      blue: "Синяя"
    },
    actionType: {
      unknown: "Неизвестно",
      legend: "Легенда",
      legend_master: "Игромастерская легенда",
      passport_photo: "Фото на паспорт",
      photos: "Фото",
      callsign: "Позывной",
      suit: "Костюм",
      fraction: "Группировка",
      new_request: "Новая заявка"
    },
    actionMessage: {
      unknown: "Неизвестно",
      legend: "Изменения в легенде",
      legend_master: "Игромастерская легенда",
      passport_photo: "Изменено фото на паспорт",
      photos: "Произведены изменения в фото",
      callsign: "Изменен позывной",
      suit: "Изменен костюм",
      fraction: "Изменена группировка",
      new_request: "Добавлена новая заявка"
    }
  },
  nav: {
    profile: "Профиль",
    events: "Мероприятия",
    requests: "Заявки",
    members: "Участники",
    registration: "Регистрация",
    notifications: "Оповещения",
    messages: "Сообщения",
    staff: "Персонал",
    items: "Предметы",
    firmwares: "Прошивки",
    locations: "Локации",
    quests: "Задания"
  },
  routes: {
    Dashboard: "Панель",
    Profile: "Профиль",
    ProfileEdit: "Редактирование профиля",
    ProfileCreate: "Создание персонажа",
    Events: "Мероприятия",
    EventMembers: "Участники",
    AdminRequests: "Заявки",
    AdminMembers: "Участники",
    AdminRegistration: "Регистрация",
    AdminStaff: "Персонал",
    AdminNotifications: "Оповещения",
    AdminMessages: "Сообщения",
    AdminItems: "Предметы",
    AdminItemEdit: "Редактирование предмета",
    AdminFirmwares: "Прошивки",
    AdminFirmwareAdd: "Добавление прошивки",
    AdminLocations: "Локации",
    AdminLocationEdit: "Редактирование локации",
    AdminQuests: "Задания",
    Scan: "Сканирование",
    Register: "Регистрация",
    Login: "Вход",
    Restore: "Восстановление пароля",
    PassChange: "Изменение пароля"
  },
  errors: {
    api: {
      ERR_SERVICE: "Ошибка сервиса",
      ERR_NOT_FOUND: "Не найдено",
      ERR_ALREADY_EXISTS: "Запись уже существует",
      ERR_ALREADY_ENABLED: "Уже активно",
      ERR_ALREADY_DISABLED: "Уже неактивно",
      ERR_BAD_REQUEST: "Неверный запрос",
      ERR_BAD_PARAM: "Неверный параметр",
      ERR_NOT_ALLOWED: "Действие не разрешено",
      ERR_BAD_JWT: "Неверный JWT-токен",
      ERR_BALANCE_NOT_ENOUGH: "Недостаточно денег",
      ERR_BAD_AUTH: "Ошибка авторизации",
      ERR_BAD_SIGNATURE: "Неверная подпись"
    },
    bad_param: {
      password: {
        invalid_restore_token: "���������������� ����� �������������� ������",
        invalid_current_password: "�������� ������� ������"
      }
    },
    not_allowed: {
      request: {
        invalid_check_state: "�������� ������ ��������� � ������� ��������� �������� ������"
      },
      member: {
        other_member_editing: "�������������� ������� ��������� ���������",
        confirmed_request_edit: "�������������� �������������� ������ ���������",
        max_user_members_reached: "���������� ������������ ���������� ���������� ��� ������������"
      }
    },
    fraction_full: {
      request: {
        members_limit_reached: "�� ������� ��������� ����� ���������� ��� �������",
        requests_limit_reached: "�� ������� ��������� ����� ������ ��� �������"
      }
    },
    service: {
      mail: {
        create_commented_email: "�� ������� ������������ email � ����������� � ������",
        create_declined_email: "�� ������� ������������ email �� ���������� ������"
      }
    }
  }
};

